// @ts-nocheck







import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import {
  convertDataFromServer as convertDataFromServerMonth,
  convertDataToServer as convertDataToServerMonth } from
'./federalHighwayCalculationMonth';
import { fetchRequest } from './index';

export const convertDataToServer = (
federalHighwayCalculation) => (
{
  ...federalHighwayCalculation,
  sum: convertFromRubToKop(federalHighwayCalculation.sum),
  months: federalHighwayCalculation.months.map(convertDataToServerMonth)
});

export const convertDataFromServer = (
federalHighwayCalculation) => (
{
  ...federalHighwayCalculation,
  sum: convertFromKopToRub(federalHighwayCalculation.sum),
  months: federalHighwayCalculation.months.map(convertDataFromServerMonth)
});

const basedUrl = 'federalHighwayCalculation';
const federalHighwayCalculation = new CommonApi(
  basedUrl,
  'расчет проезда по федеральным трассам',
  convertDataToServer,
  convertDataFromServer
);

export const updateCalculations = async (
vehiclePlanId) =>
{
  const updated = await fetchRequest.put(
    `/${basedUrl}/updateCalculations/${vehiclePlanId}`
  );
  if (updated) return updated;
  throw new Error(`Не удалось отредактировать`);
};

const calculate = async (vehiclePlanId) => {
  const updated = await fetchRequest.put(
    `/${basedUrl}/calculate/${vehiclePlanId}`
  );
  if (updated) return updated;
  throw new Error(`Не удалось произвести расчет`);
};

const changeStatus = async (
vehiclePlanId,
status) =>
{
  const updated = await fetchRequest.put(`/${basedUrl}/changeStatus`, {
    vehiclePlanId,
    status
  });
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус`);
};

export default {
  ...federalHighwayCalculation,
  updateCalculations,
  changeStatus,
  calculate
};
